import { IGridOperator } from 'app/shared/model/grid-operator.model';
import { IProductOfferingPrice } from 'app/shared/model/product-offering-price.model';
import { MeterType } from 'app/shared/model/enumerations/meter-type.model';
import { ProductType } from 'app/shared/model/enumerations/product-type.model';
import { GridOperatorCostType } from 'app/shared/model/enumerations/grid-operator-cost-type.model';

export interface IGridOperatorCapacity {
  id?: number;
  capacityCode?: string;
  description?: string | null;
  meterType?: keyof typeof MeterType | null;
  productType?: keyof typeof ProductType | null;
  type?: keyof typeof GridOperatorCostType | null;
  trancheLowerBound?: number | null;
  trancheUpperBound?: number | null;
  gridOperator?: IGridOperator | null;
  productOfferingPrices?: IProductOfferingPrice[] | null;
}

export const defaultValue: Readonly<IGridOperatorCapacity> = {};
